// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_CREATE_TOPIC = "Zalo\u017e f\u00f3rum";
export const GROUP_LIST = "Seznam skupin";
export const LIST_OF_FORUMS = "Seznam f\u00f3r";
export const SEO_DESCRIPTION_FORUM_category = "V\u0161echno na t\u00e9ma %(category)s, co maminky zaj\u00edm\u00e1. M\u00edsto pln\u00e9 zku\u0161enost\u00ed, rad, tip\u016f a trik\u016f p\u0159\u00edmo z prvn\u00ed ruky.";
export const SEO_TITLE_FORUM_TOPICS = "V\u0161echno, co maminky zaj\u00edm\u00e1";
